import { render, staticRenderFns } from "./giveThumbUp.vue?vue&type=template&id=f23997d6&scoped=true&"
import script from "./giveThumbUp.vue?vue&type=script&lang=js&"
export * from "./giveThumbUp.vue?vue&type=script&lang=js&"
import style0 from "./giveThumbUp.vue?vue&type=style&index=0&id=f23997d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23997d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f23997d6')) {
      api.createRecord('f23997d6', component.options)
    } else {
      api.reload('f23997d6', component.options)
    }
    module.hot.accept("./giveThumbUp.vue?vue&type=template&id=f23997d6&scoped=true&", function () {
      api.rerender('f23997d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/giveThumbUp.vue"
export default component.exports